var _desc, _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreece(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 400,
    viewBox: "0 0 27 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Flag of Greece")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 18,
    fill: "#0d5eaf"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    stroke: "white",
    d: "M5,0V11 M0,5H10 M10,3H27 M10,7H27 M0,11H27 M0,15H27"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreece);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjYwMCIgaGVpZ2h0PSI0MDAiIHZpZXdCb3g9IjAgMCAyNyAxOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZGVzYz5GbGFnIG9mIEdyZWVjZTwvZGVzYz4KICA8cmVjdCB3aWR0aD0iMjciIGhlaWdodD0iMTgiIGZpbGw9IiMwZDVlYWYiLz4KICA8cGF0aCBmaWxsPSJub25lIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZT0id2hpdGUiIGQ9Ik01LDBWMTEgTTAsNUgxMCBNMTAsM0gyNyBNMTAsN0gyNyBNMCwxMUgyNyBNMCwxNUgyNyIvPgo8L3N2Zz4=";
export { ForwardRef as ReactComponent };